<template>
  <div class="sc-header">
    <img v-if="isHistoryMode" class="sc-header--img" src="@/assets/btn-40.svg" alt=""  @click="setHistoryMode(false)"/>
    <div v-show="!isHistoryMode"  class="sc-header--title" >  {{ projectTitleName + "腦力健身房"}}  </div>
    <div v-show="isHistoryMode" class="sc-header--title" @click="setHistoryMode(false)">  {{ "對話紀錄" }}  </div>
      <!-- <el-dropdown v-if="!Onboarding_action" :hide-on-click="true">
        <span class="el-dropdown-link">
          <img class="header-info" src="./assets/iconInfo.png" alt="" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="showOnboarding_">你可以做些什麼?</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->

    <div id="minifyBtn" class="sc-header--minify-button" @click="onMinify('')">
      <div ></div>
    </div>
    <div id="closeBtn" class="sc-header--close-button" @click="onClose('')">
      <div ></div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    onClose: {
      type: Function,
      required: true
    },
    onMinify: {
      type: Function,
      required: true
    },
    projectTitleName: {
      type: String,
      default: () => ''
    },
    Onboarding_action: {
      type: Boolean,
      default: () => false
    },
    projectId: {
      type: String,
      default: () => ''
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isApp: {
      type: Boolean,
      default: false
    },
    isHistoryMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setHistoryMode(value) {
      this.$emit('show-input-bar',value)
    },
    showOnboarding_(){
      this.$emit("showOnboarding", "")
    },
    toggleUserList() {
      this.inUserList = !this.inUserList
      this.$emit("userList", this.inUserList)
    }
  },
  data() {
    return {
      inUserList: false
    }
  }
}
</script>
<style scoped>
@import "./styles/header.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/Header.vue